import { cn } from '@/lib/utils'
import type { PurchaseOrderStatus } from '@/types/purchaseOrders'

export const PO_STATUS_LABEL: Record<PurchaseOrderStatus, string> = {
  DRAFT: 'Draft',
  SENT: 'Sent',
  RECEIVED: 'Received',
  CANCELLED: 'Cancelled',
}

const PO_STATUS_STYLE: Record<PurchaseOrderStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-700',
  SENT: 'bg-blue-100 text-blue-700',
  RECEIVED: 'bg-green-100 text-green-700',
  CANCELLED: 'bg-red-50 text-red-600 line-through decoration-red-300',
}

export function PoStatusBadge({ status }: { status: PurchaseOrderStatus }) {
  return (
    <span
      className={cn(
        'inline-flex whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium',
        PO_STATUS_STYLE[status],
      )}
    >
      {PO_STATUS_LABEL[status]}
    </span>
  )
}

/** A stored date or instant as `13 Oct 2026`, or a dash. */
export function formatPoDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso)
  return Number.isNaN(d.getTime())
    ? '—'
    : d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
}
